
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationP as ObiLocationPElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-p.js';
 
 
 

 
 export const ObiLocationP = createComponent({
   react: React,
   tagName: 'obi-location-p',
   elementClass: ObiLocationPElement,
   events: {
     
   }
  });
 
 